import { ReactElement } from 'react';
import messages from '../locales/messages';
import './PAROI.scss';
import { createUseTranslation } from '../../../common/hooks/widgets/useTranslation';
import { usePAROISelector } from '../lib/redux/hooks';

export interface thanksProps {
  annualSpend: number;
  numberDepartments: number;
  numberParticipants: number;
}

const ThanksDetails = ({
  annualSpend,
  numberDepartments,
  numberParticipants,
}: thanksProps): ReactElement => {
  const AEMMessages = usePAROISelector((state) => state.translations.messages);

  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <div className="thanks__requirement thanks__pad4">
      {useTranslation('messages.thankYouAnnual')}
      <strong>{` $${annualSpend}K`}</strong>
      <br />
      {useTranslation('messages.thankyouNDepartmetn')}
      <strong>{` ${numberDepartments}`}</strong>
      <br />
      {useTranslation('messages.thankyouNParticipants')}
      <strong>{` ${numberParticipants}`}</strong>
      <br />
    </div>
  );
};

export default ThanksDetails;
